<!-- Разделы настроек компании. -->
<template>
  <div class="settings-container">
    <base-nav
      title="Настройки компании"
      back-fallback="Home"
    />

    <div class="settings-masonry">
      <RolesSettingsSection />
      <TelemetrySettingsSection />
      <TransportSettingsSection />
      <RegistriesSettingsSection />
      <ToolsSettingsSection />
      <AccessSettingsSection />
      <DocumentsSettingsSection />
      <ExpensesSettingsSection />
      <ReferenceSettingsSection />
    </div>
  </div>
</template>

<script>
import AccessSettingsSection from "@/components/Settings/AccessSettingsSection.vue";
import DocumentsSettingsSection from "@/components/Settings/DocumentsSettingsSection.vue";
import ExpensesSettingsSection from "@/components/Settings/ExpensesSettingsSection.vue";
import ReferenceSettingsSection from "@/components/Settings/ReferenceSettingsSection.vue";
import RegistriesSettingsSection from "@/components/Settings/RegistriesSettingsSection.vue";
import RolesSettingsSection from "@/components/Settings/RolesSettingsSection.vue";
import TelemetrySettingsSection from "@/components/Settings/TelemetrySettingsSection.vue";
import ToolsSettingsSection from "@/components/Settings/ToolsSettingsSection.vue";
import TransportSettingsSection from "@/components/Settings/TransportSettingsSection.vue";

export default {
  name: "SettingsPage",

  components: {
    AccessSettingsSection,
    DocumentsSettingsSection,
    ExpensesSettingsSection,
    ReferenceSettingsSection,
    RegistriesSettingsSection,
    RolesSettingsSection,
    TelemetrySettingsSection,
    ToolsSettingsSection,
    TransportSettingsSection,
  },

};
</script>

<style scoped>
.settings-container {
  flex-grow: 1;
}

.settings-masonry {
  column-count: 3;
  column-gap: var(--base-out-indent, 20px);
}

@media (max-width: 1100px) {
  .settings-masonry {
    column-count: 2;
  }
}

@media (max-width: 640px) {
  .settings-masonry {
    column-count: 1;
  }
}
</style>
